module.exports = __webpack_public_path__ + "img/sportwetten.9c9acbd3.jpg";